import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import ViewContext from '@modules/order/contexts/view-context'
import React, { FC, useContext } from 'react'
import get from 'lodash/result'
import last from 'lodash/last'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import formatNumberByLocale from '@utils/format-number-by-locale'
import HierarchyCell from '@modules/order/components/CellTemplates/components/HierarchyCell/HierarchyCell'
import FieldSkeleton from '@api/order/components/CellLoaders/FieldSkeleton'
import { KPIUIStore } from '@modules/order/stores/view/KPI/KPIUIStore'
import { CATEGORY_INTERNAL_SEPERATOR } from '@modules/order/constants/uiConstants'
import formatCurrencyValueByLocale from '@utils/format-currency-value-by-locale'
import useOrderContext from '@modules/order/hooks/use-order-context'
import { nav, stores } from '@stores'
import { getKPICurrency } from '@modules/order/utils/get-kpi-currency'
import { find } from 'lodash'

const EnhancedHeirarchyKPIValue: FC<CellItem> = ({ rowData, column }) => {
  const { uiStore } = useContext(ViewContext)
  const { getHierarchy, getDoorWiseHierarchyKPIs } = uiStore as KPIUIStore
  const {
    productConfiguration: { allMetricsAttributes }
  } = stores
  const {
    uiStore: {
      dataStore: { summary }
    }
  } = useOrderContext()
  const {
    queryParams: { orderType }
  } = nav
  if (!rowData) {
    return (
      <HierarchyCell>
        <FieldSkeleton />
      </HierarchyCell>
    )
  }
  const attributeMetaData = find(
    allMetricsAttributes,
    metric => metric?.id === column?.enhancedField
  )
  const isCurrencyValue =
    attributeMetaData?.type === 'number' &&
    attributeMetaData?.attributeFormatMetadata?.type === 'currency'
  const isPercentageValue =
    attributeMetaData?.type === 'number' &&
    attributeMetaData?.attributeFormatMetadata?.type === 'percentage'
  const currency = isCurrencyValue ? getKPICurrency(orderType, summary) : ''

  const hierarchy = column?.doorId
    ? rowData?.name && getDoorWiseHierarchyKPIs(column?.doorId, rowData?.name)
    : rowData?.name && last(getHierarchy(rowData?.name))
  const isMainHeirarchy = !rowData?.name?.includes(CATEGORY_INTERNAL_SEPERATOR)
  const val = Number(get(hierarchy, column?.enhancedField) ?? 0)
  return (
    <HierarchyCell>
      <Typography variant={isMainHeirarchy ? 'subtitle1' : 'caption'}>
        {isCurrencyValue
          ? formatCurrencyValueByLocale(currency, val)
          : isPercentageValue
          ? `${formatNumberByLocale(val, 2, 2)}%`
          : formatNumberByLocale(val, 0, 2)}
      </Typography>
    </HierarchyCell>
  )
}

export default EnhancedHeirarchyKPIValue
